export default "__VITE_ASSET__BMZFxQcP__"